import { PLAN_SUBSCRIPTION } from '../utils'

const CheckIcon = () => (
    <svg
        aria-hidden
        viewBox="0 0 20 20"
        className=" mt-0.5 h-4 w-4 shrink-0 text-brand"
    >
        <path
            d="M4 10.5l4 4 8-9"
            fill="none"
            stroke="currentColor"
            strokeWidth="2.2"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)

const DotIcon = () => (
    <span
        aria-hidden
        className=" mt-2 h-1 w-1 shrink-0 rounded-full bg-text-muted"
    />
)

export default function PlanDetail({
    tier,
    price,
    isPriceLoading,
}: {
    tier: IPlanTier
    /** Server price for this fund, subscription tier only. */
    price?: number
    isPriceLoading?: boolean
}) {
    const isSubscription = tier.servicePackage === PLAN_SUBSCRIPTION

    const headline = isSubscription
        ? price
            ? `${price.toLocaleString('fa-IR')} تومان`
            : isPriceLoading
            ? '…'
            : 'قیمت در دسترس نیست'
        : tier.headline

    return (
        <section className=" animate-fade-in rounded-sheet bg-white p-4 shadow-card">
            <h2 className=" text-base font-bold text-heading">
                نسخه‌ی {tier.name}
            </h2>
            <p className=" mt-1 text-xs leading-5 text-text-secondary">
                {tier.tagline}
            </p>

            {/* The one display-scale element on the page: what it costs. */}
            <p className=" mt-4 text-2xl font-bold leading-tight text-heading">
                {headline}
            </p>
            {!!tier.priceCaption && (!isSubscription || !!price) && (
                <p className=" mt-1.5 text-xs text-text-secondary">
                    {tier.priceCaption}
                </p>
            )}

            <ul className=" mt-4 space-y-2.5 border-t border-divider pt-4">
                {tier.gains.map((gain) => (
                    <li
                        key={gain}
                        className=" flex gap-2 text-sm leading-6 text-text-body"
                    >
                        <CheckIcon />
                        <span>{gain}</span>
                    </li>
                ))}
            </ul>

            {!!tier.carried.length && (
                <ul className=" mt-3 space-y-2 border-t border-divider pt-3">
                    <li className=" text-xs font-bold text-text-secondary">
                        {tier.carriedLabel}
                    </li>
                    {tier.carried.map((item) => (
                        <li
                            key={item}
                            className=" flex gap-2 text-xs leading-5 text-text-secondary"
                        >
                            <CheckIcon />
                            <span>{item}</span>
                        </li>
                    ))}
                </ul>
            )}

            {!!tier.limits.length && (
                <ul className=" mt-3 space-y-2 border-t border-divider pt-3">
                    <li className=" text-xs font-bold text-text-muted">
                        {tier.limitsLabel}
                    </li>
                    {tier.limits.map((limit) => (
                        <li
                            key={limit}
                            className=" flex gap-2 text-xs leading-5 text-text-secondary"
                        >
                            <DotIcon />
                            <span>{limit}</span>
                        </li>
                    ))}
                </ul>
            )}
        </section>
    )
}
